export default __webpack_public_path__ + "static/media/icon_articles.3be673b9.svg";